import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ClientEventApi } from 'wklr-backend-sdk/apis';
import { getSerializable } from '@/utility';
/** Errorオブジェクトを文字列に変換し、maxLength文字以下に切り詰める */
var stringifyErrorObject = function stringifyErrorObject(error) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
  return JSON.stringify(getSerializable(error)).substr(0, maxLength);
};
export default (function (_ref, inject) {
  var app = _ref.app;
  var api = new ClientEventApi(undefined, '', app.$axios);
  var sendTelemetry = function sendTelemetry(payload, route) {
    return api.postClientEvent(JSON.stringify(_objectSpread(_objectSpread({}, payload), {}, {
      hostname: location.hostname,
      rev: process.env.versionInfo,
      ua: navigator ? navigator.userAgent : navigator,
      route: {
        fullPath: route.fullPath,
        name: route.name
      }
    }))).catch(function (error) {
      // ユーザーに知らせる必要がないので無視する
    });
  };

  /**
   * テレメトリ情報を送信する
   * @param payload cf. `frontend/types/Telemetry.ts`
   */
  var $telemetry = {
    sendExportTelemetry: function sendExportTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'export'
              }, payload), route);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    sendAssertionErrorTelemetry: function sendAssertionErrorTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'assertionError'
              }, payload), route);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    sendErrorTelemetry: function sendErrorTelemetry(error, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return sendTelemetry({
                type: 'error',
                errorObjectJSON: stringifyErrorObject(error)
              }, route);
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    sendEnvironmentTelemetry: function sendEnvironmentTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'env'
              }, payload), route);
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    sendDocumentViewTelemetry: function sendDocumentViewTelemetry(route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return sendTelemetry({
                type: 'pageview'
              }, route);
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    sendPDFPageViewTelemetry: function sendPDFPageViewTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'pdf-page-view'
              }, payload), route);
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    sendWebSectionViewTelemetry: function sendWebSectionViewTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'web-section-view'
              }, payload), route);
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    sendImpressionTelemetry: function sendImpressionTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'impression'
              }, payload), route);
            case 1:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    sendClickTelemetry: function sendClickTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'click'
              }, payload), route);
            case 1:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    sendHoverTelemetry: function sendHoverTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'hover'
              }, payload), route);
            case 1:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    sendLookupTelemetry: function sendLookupTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'lookup'
              }, payload), route);
            case 1:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    sendPurchaseLinkTelemetry: function sendPurchaseLinkTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'purchase-link'
              }, payload), route);
            case 1:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    sendToggleViewerTelemetry: function sendToggleViewerTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'toggle-viewer'
              }, payload), route);
            case 1:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    sendWandhAskTelemetry: function sendWandhAskTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'wandh-ask'
              }, payload), route);
            case 1:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    sendSearchTelemetry: function sendSearchTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return sendTelemetry(_objectSpread({
                type: 'search'
              }, payload), route);
            case 1:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    }
  };

  /**
   * assertionが失敗したらテレメトリ送信
   */
  var $assert = function $assert(condition, message, route) {
    if (!condition) {
      $telemetry.sendAssertionErrorTelemetry({
        message: message
      }, route).catch(function () {
        return true;
      });
    }
    return condition;
  };
  inject('telemetry', $telemetry);
  inject('assert', $assert);
});
export var useTelemetry = function useTelemetry() {
  var _useNuxtApp = useNuxtApp(),
    $telemetry = _useNuxtApp.$telemetry;
  return $telemetry;
};